import request from './../utils/request.js'

let api = {
  // 获取轮播图
  slideShowListApi(data) {
    return request({
      url: `/api/web/slideshow/list`,
      method: 'get',
      data
    })
  },
  // 获取最新新闻
  getNewestApi(data) {
    return request({
      url: `/api/web/pressCenter/getNewest/7`,
      method: 'get',
      data
    })
  },
  // 获取新闻分类
  getPressClassifyApi(data) {
    return request({
      url: `/api/web/pressCenter/getPressClassify`,
      method: 'get',
      data
    })
  },
  // 获取新闻中心列表
  getpressCenterApi(data) {
    return request({
      url: `/api/web/pressCenter/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}&classify=${data.classify}&title=${data.title ? data.title : ''}`,
      method: 'get',
      data
    })
  },
  // 获取新闻中心详情
  getpressCenterDet(data) {
    return request({
      url: `/api/web/pressCenter/${data.id}`,
      method: 'get',
      data
    })
  },
  // 获取公示公告分类
  getAnnouncementClassifyApi(data) {
    return request({
      url: `/api/web/announcement/getProjectClassify`,
      method: 'get',
      data
    })
  },
  // 获取公示公告列表
  getAnnouncementApi(data) {
    return request({
      url: `/api/web/announcement/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}&classify=${data.classify}`,
      method: 'get',
      data
    })
  },
  // 获取公示公告详情
  getAnnouncementDetApi(data) {
    return request({
      url: `/api/web/announcement/${data.id}`,
      method: 'get',
      data
    })
  },
  //党建工作列表
  getPartyBuilding(data) {
    return request({
      url: `/api/web/partyBuilding/list`,
      method: 'get',
      data
    })
  },
  //党建工作详情
  getPartyBuildingDet(data) {
    return request({
      url: `/api/web/partyBuilding/${data.id}`,
      method: 'get',
      data
    })
  },
  // 获取合作伙伴列表
  getPartnerApi(data) {
    return request({
      url: `/api/web/partner/getPartner`,
      method: 'get',
      data
    })
  },
  // 获取公司介绍
  getCompanyInfoApi(data) {
    return request({
      url: `/api/web/companyProfile/getInfo`,
      method: 'get',
      data
    })
  },
  //政策法规  /web/policy/getProjectClassify
  getProjectClassify(data) {
    return request({
      url: `/api/web/policy/getProjectClassify`,
      method: 'get',
      data
    })
  },
  //政策法规列表 web/policy/list
  getpolicyList(data) {
    return request({
      url: `/api/web/policy/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}&classify=${data.classify}`,
      method: 'get',
      data
    })
  },
  //政策法规详情
  getpolicyDet(data) {
    return request({
      url: `/api/web/policy/${data.id}`,
      method: 'get',
      data
    })
  },
  //投资项目分类  /web/project/getProjectClassify
  getTZClassify(data) {
    return request({
      url: `/api/web/project/getProjectClassify`,
      method: 'get',
      data
    })
  },
  //投资分类列表
  getTZList(data) {
    return request({
      url: `/api/web/project/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}&classify=${data.classify}&isIndexShow=${data.isIndexShow}`,
      method: 'get',
      data
    })
  },
  //党建工作列表
  getpartyBuilding(data) {
    return request({
      url: `/api/web/partyBuilding/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}&classify=${data.classify}`,
      method: 'get',
      data
    })
  },
  // 新闻分类
  getPressClassify(data) {
    return request({
      url: `/api/web/pressCenter/getPressClassify`,
      method: 'get',
      data
    })
  },
  //新闻中心列表  /web/pressCenter/list
  getpressCenter(data) {
    return request({
      url: `/api/web/pressCenter/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}&classify=${data.classify}`,
      method: 'get',
      data
    })
  },
  // 获取三大战略性新兴产业集群
  getStrategy(data) {
    return request({
      url: `/api/web/project/getStrategy`,
      method: 'get',
      data
    })
  },
  // 获取聚焦两大重点投资领域
  getInvestor(data) {
    return request({
      url: `/api/web/project/getInvestor`,
      method: 'get',
      data
    })
  },
  // 获取业务板块分类
  getBusinessClassify(data) {
    return request({
      url: `/api/web/business/getBusinessClassify`,
      method: 'get',
      data
    })
  },
  // 获取业务板块列表
  getBusinessList(data) {
    return request({
      url: `/api/web/business/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}&classify=${data.classify}`,
      method: 'get',
      data
    })
  },
  // 搜索
  getSearchList(data) {
    return request({
      url: `/api/web/pressCenter/getClassifyPressList?pageSize=${data.pageSize}&pageNum=${data.pageNum}&title=${data.title}`,
      method: 'get',
      data
    })
  },
  //业务板块详情 /web/business/
  getbusiness(data) {
    return request({
      url: `/api/web/business/${data.id}`,
      method: 'get',
      data
    })
  },
}

export default api

